import { OPEN_BANKING_FLOWS, FLOW_TYPES } from '../constants'
import { isIframe } from 'iframe-support'
import store from '../stores/configureStore'
import _ from 'lodash'
import { getFlowType } from './url-utils'
import { post } from '../../calculator/lib/xhr'
import { getTrafficSource } from './mgmUtils'
import { generateFIFlowUrl } from '../../experiments/fiFlow'
import { hasAddFiPostMigration } from '../../experiments/migrateRoutes'
import * as ViewActions from '../actions/Actions'
import { getSessionDataPayload } from 'transfer/utils/session'

export function requireFundingInstrumentRedirect(props) {
  const mainWindow = isIframe ? window.top : window
  const shopsInformation = {
    ...((store.getState().server.env === FLOW_TYPES.PPSHOPS && {
      productId: store.getState().recipient.productId,
      productQuantity: store.getState().recipient.productQuantity,
    }) ||
      {}),
  }
  const fiFlowPayload = {
    flowType: props.flowType || getFlowType(),
    amount: props.amount || store.getState().amount.amount,
    currencyCode: props.currencyCode || store.getState().amount.currencyCode,
    payerId: props.payerId || store.getState().recipient.payerId,
    recipient: props.recipient || store.getState().recipient.recipient,
    obFlow: OPEN_BANKING_FLOWS.ADD_BANK,
    unilateralName: props.unilateralName || store.getState().unilateral.name,
    unilateralCountryCode:
      props.unilateralCountryCode || store.getState().unilateral.countryCode,
    mayCashAdvanceFeesApply:
      props.mayCashAdvanceFeesApply ||
      store.getState().recipient.mayCashAdvanceFeesApply,
    isPurchase: _.get(
      props,
      'isPurchase',
      store.getState().transaction.isPurchase
    ),
    isMgm: _.get(props, 'isMgm', store.getState().server.isMgm),
    mgmTrafficSource: getTrafficSource(),
    displayName: props.displayName || store.getState().recipient.displayName,
    thumbnailUrl: props.thumbnailUrl || store.getState().recipient.thumbnailUrl,
    networkId: props.networkId || store.getState().recipient.networkId,
    flowIntent: props.flowIntent || store.getState().server.flowIntent,
    note: props.note || store.getState().note.note,
    token: props.token || store.getState().recipient.token,
    isFirstFeeFreeEligible: _.get(
      props,
      'isFirstFeeFreeEligible',
      store.getState().transaction.isFirstFeeFreeEligible
    ),
    isAShop: _.get(props, 'isAShop', store.getState().recipient.isAShop),
    ...(props.shopsInformation || shopsInformation),
    ...getSessionDataPayload(),
  }
  const fiFlowUrl = generateFIFlowUrl(fiFlowPayload)
  const fiNewUrl = '/myaccount/transfer/flow/fi/new'
  if (hasAddFiPostMigration()) {
    post(fiNewUrl, fiFlowPayload)
      .then(response => {
        const { redirectURL = {} } = response
        mainWindow.location.assign(redirectURL)
      })
      .catch(err => {
        return props.dispatch(ViewActions.showError(err))
      })
  } else {
    mainWindow.location.assign(fiFlowUrl)
  }
}
